var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 70,
    viewBox: "0 0 47 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6683 70C18.1083 70 23.335 64.7733 23.335 58.3333V46.6666H11.6683C5.22833 46.6666 0.00166702 51.8933 0.00166702 58.3333C0.00166702 64.7733 5.22833 70 11.6683 70Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00166702 35C0.00166702 28.56 5.22833 23.3334 11.6683 23.3334H23.335V46.6667H11.6683C5.22833 46.6667 0.00166702 41.44 0.00166702 35Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00166702 11.6667C0.00166702 5.22667 5.22833 0 11.6683 0H23.335V23.3333H11.6683C5.22833 23.3333 0.00166702 18.1067 0.00166702 11.6667Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.335 0H35.0017C41.4417 0 46.6683 5.22667 46.6683 11.6667C46.6683 18.1067 41.4417 23.3333 35.0017 23.3333H23.335V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6683 35C46.6683 41.44 41.4417 46.6667 35.0017 46.6667C28.5617 46.6667 23.335 41.44 23.335 35C23.335 28.56 28.5617 23.3334 35.0017 23.3334C41.4417 23.3334 46.6683 28.56 46.6683 35Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.67,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFigma);
export default __webpack_public_path__ + "static/media/logos_figma.12d87b4b6c90ff4d6446c5336b8cfdf9.svg";
export { ForwardRef as ReactComponent };